<template>
  <div class="card">
    <div class="card-image">
      <figure class="image is-4by3">
        <img :src="data['cover']" :alt="data['title']" />
      </figure>
    </div>
    <div class="card-content">
      <router-link :to="{name:'film', params: data}" :title="data.title">{{data["title"]}}</router-link>
      <br />
      <span class="code">{{data['code']}}</span>
      <time v-bind:datetime="data['release_date']">{{data['release_date']}}</time>
      <div class="tags has-addons">
        <span class="tag" :class="{'is-info': data.mosaic}">{{data.mosaic ? '有码' : '无码'}}</span>
        <span class="tag is-link" v-if="data.links.length > 0">磁力</span>
        <span class="tag is-success" v-if="hasHD">高清</span>
        <span class="tag is-warning" v-if="hasSubtitle">字幕</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilmCard",
  props: {
    data: Object
  },
  data() {
    return {
      hasHD: false,
      hasSubtitle: false
    };
  },
  mounted: function() {
    for (let i = 0; i < this.data.links.length; i++) {
      const tags = this.data.links[i]["tags"];
      for (let j = 0; j < tags.length; j++) {
        if (tags[j] == "高清") {
          this.hasHD = true;
        }
        if (tags[j] == "字幕") {
          this.hasSubtitle = true;
        }
      }
    }
  },
  methods: {}
};
</script>

<style>
.card .card-content a {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card .card-content span.code {
  margin-right: 0.5rem;
  color: #d64f4f;
}
</style>
